module.exports = __webpack_public_path__ + "static/media/clients_1.03897899.jpg";